var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6625 12.598C3.9125 12.598 3.28125 12.3418 2.76875 11.8293C2.25625 11.3043 2 10.6668 2 9.9168V2.99805H13.0063C13.3938 2.99805 13.725 3.1418 14 3.4293C14.2875 3.7043 14.4313 4.0418 14.4313 4.4418V6.1668C14.4313 6.5543 14.2875 6.8918 14 7.1793C13.725 7.4543 13.3938 7.5918 13.0063 7.5918H11.7125V9.9168C11.7125 10.6668 11.4563 11.3043 10.9438 11.8293C10.4313 12.3418 9.8 12.598 9.05 12.598H4.6625ZM4.6625 11.398H9.05C9.45 11.398 9.79375 11.2543 10.0813 10.9668C10.3688 10.6793 10.5125 10.3293 10.5125 9.9168V4.19805H3.2V9.9168C3.2 10.3293 3.34375 10.6793 3.63125 10.9668C3.91875 11.2543 4.2625 11.398 4.6625 11.398ZM11.7125 6.3918H13.0063C13.0688 6.3918 13.1188 6.37305 13.1562 6.33555C13.2062 6.28555 13.2313 6.2293 13.2313 6.1668V4.4418C13.2313 4.3668 13.2062 4.31055 13.1562 4.27305C13.1188 4.22305 13.0688 4.19805 13.0063 4.19805H11.7125V6.3918Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCoffee);
export default __webpack_public_path__ + "static/media/ico_coffee.ba511c9c56a54e39e4af67248eb2d6ac.svg";
export { ForwardRef as ReactComponent };